export const pricingTiers = [
  {
    id: 'hourly',
    name: { en: 'Companion & homemaker care', es: 'Compañía y ayuda en el hogar' },
    detail: { en: 'Companionship, meals, housekeeping, reminders', es: 'Compañía, comidas, limpieza, recordatorios' },
    price: { en: '$30–$34 / hr', es: '$30–$34 / hora' },
  },
  {
    id: 'personal',
    name: { en: 'Personal care', es: 'Cuidado personal' },
    detail: { en: 'Bathing, dressing, mobility, toileting', es: 'Baño, vestirse, movilidad, ir al baño' },
    price: { en: '$32–$36 / hr', es: '$32–$36 / hora' },
  },
  {
    id: 'dementia',
    name: { en: "Alzheimer's & dementia care", es: 'Cuidado de Alzheimer y demencia' },
    detail: { en: 'Dementia-trained caregiver, safety supervision', es: 'Cuidador capacitado en demencia, supervisión' },
    price: { en: '$34–$38 / hr', es: '$34–$38 / hora' },
  },
  {
    id: 'overnight',
    name: { en: 'Overnight care', es: 'Cuidado nocturno' },
    detail: { en: '10–12 hour awake or sleeping shift', es: 'Turno de 10–12 horas, despierto o dormido' },
    price: { en: '$280–$360 / night', es: '$280–$360 / noche' },
  },
  {
    id: 'live-in',
    name: { en: '24-hour live-in care', es: 'Cuidado interno de 24 horas' },
    detail: { en: 'Round-the-clock support in the home', es: 'Apoyo continuo en el hogar' },
    price: { en: '$350–$450 / day', es: '$350–$450 / día' },
  },
]
